/* eslint-disable @typescript-eslint/no-explicit-any */
import { VideoStatusEnum } from '@shared/enum/video-status.enum';
import { IBackendDate, IVideo } from '@shared/interface/model.interface';

export class VideoDto implements IVideo {
  public id?: number;
  public code?: string;
  public status?: VideoStatusEnum = VideoStatusEnum.TO_VALIDATE;
  public fileName?: string;
  public fileSize?: number;
  public createdAt?: IBackendDate = undefined;
  public validatedAt?: IBackendDate = undefined;
  public invalidatedAt?: IBackendDate = undefined;

  constructor(init?: Partial<any>) {
    (Object as any).assign(this, init);
  }
}
